/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The component to display selected wizard params
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @version 1.10.0
 * @since 1.2.0
 */

import { Typography } from '@nexign/scc-ui-kit';

import { WizardReportTitleStyled } from '../WizardReport/styled/WizardReportStyled';
import {
    WizardSummaryInfoHtmlStyled,
    WizardSummaryContainerStyled,
    WizardSummaryParamBodyStyled,
    WizardSummaryParamContainerStyled,
    WizardSummaryParamTitleStyled,
} from './styled/WizardSummaryStyled';
import WizardSummaryRow from './WizardSummaryRow';

export interface IWizardSummaryParam {
    hide?: boolean;
    limit?: number;
    limitMore?: string;
    limitLess?: string;
    title?: string;
    values: string[];
}

export interface IWizardSummary {
    dataName?: string;
    params: IWizardSummaryParam[];
    title?: string;
    instructionHtml?: string;
}

export const WizardSummary = (props: IWizardSummary) => {
    return (
        <WizardSummaryContainerStyled data-name={props.dataName || ''}>
            {
                !!props.title &&
                <WizardReportTitleStyled>
                    {props.title}
                </WizardReportTitleStyled>
            }
            {
                props.params.filter(item => !item.hide).map((param, index) => (
                    <WizardSummaryParamContainerStyled key={index}>
                        {
                            param.title &&
                            <WizardSummaryParamTitleStyled>
                                {param.title}
                            </WizardSummaryParamTitleStyled>
                        }
                        <WizardSummaryParamBodyStyled>
                            <WizardSummaryRow {...param}/>
                        </WizardSummaryParamBodyStyled>
                    </WizardSummaryParamContainerStyled>
                ))
            }
            {
                !!props.instructionHtml &&
                <WizardSummaryInfoHtmlStyled>
                    <Typography isDangerousInnerHTML>{props.instructionHtml}</Typography>
                </WizardSummaryInfoHtmlStyled>
            }
        </WizardSummaryContainerStyled>
    )
};

export default WizardSummary;
